import { Component } from '@angular/core';

/**
 * User details.
 */
@Component({
  templateUrl: './user.component.html',
})
export class UserComponent {}
